import { createContext, useContext, useRef } from 'react';
import { Toast } from 'primereact/toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const toast = useRef(null);

  const showSuccess = (summary) => {
    toast.current?.show({
      severity: 'success',
      summary,
      life: 3000
    });
  };

  const showError = (summary) => {
    toast.current?.show({
      severity: 'error',
      summary,
      life: 5000
    });
  };

  return (
    <ToastContext.Provider value={{ showSuccess, showError }}>
      {children}
      <Toast ref={toast} position="top-right" />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};
